export default __webpack_public_path__ + "static/DesignWithUs-b1f9cfa7bff0a160dfbaf6e005708be2.mp4";